<template>
  <div class="article-wrapper">
    <loading-spinner v-show="!isReady"></loading-spinner>
    <div class="article-info" :class="{[`opacity0-3`]: !isReady}">
      <div class="title">제목</div>
      <div>
        <input
          type="text"
          placeholder="제목을 입력해주세요."
          v-model="inputTitle"
        />
      </div>
      <div class="title">
        날짜
      </div>
      <div>
        <input type="date" v-model="inputDate" />
      </div>
      <div class="category d-flex">
        <div>
          <div class="title">
            분류
          </div>
          <select class="search-filter" v-model="inputCategory">
            <option value="">선택</option>
            <option value="article">기사</option>
            <option value="video">영상</option>
            <option value="notice">공지</option>
          </select>
        </div>
        <div>
          <div class="title">URL</div>
          <div>
            <input
              type="text"
              placeholder="해당 링크를 입력해주세요."
              v-model="inputUrl"
              :disabled="inputCategory === 'notice'"
            />
          </div>
        </div>
      </div>
      <vue-editor
        v-if="inputCategory === 'notice'"
        class="editor"
        useCustomImageHandler
        @image-added="imgAddHandler"
        v-model="htmlForEditor"
        ref="editor"
      ></vue-editor>
    </div>
    <div
      class="btn-complete"
      @click="uploadNews"
      :class="{[`opacity0-3`]: !isReady}"
    >
      작성 완료
    </div>
  </div>
</template>

<script>
import {VueEditor} from "vue2-editor";
import {fileUpload} from "@/api/index.js";
import LoadingSpinner from "../loadingSpinner.vue";
export default {
  components: {VueEditor, LoadingSpinner},
  data() {
    return {
      htmlForEditor: "",
      image: "",
      sample: "",
      inputDate: new Date().toISOString().slice(0, 10),
      inputTitle: "",
      inputUrl: "",
      inputCategory: "",
      formData: new FormData(),
      content: "",
      isReady: true,
    };
  },
  methods: {
    checkValidation() {
      // title, 본문, 날짜, 분류 다 선택 되었는지 체크
      if (this.inputTitle === undefined || this.inputTitle === "") {
        return false;
      }
      if (this.inputDate === undefined || this.inputDate === "") {
        return false;
      }

      if (this.inputCategory === undefined || this.inputCategory === "") {
        return false;
      }

      this.content =
        this.inputCategory === "notice" ? this.htmlForEditor : this.inputUrl;

      if (this.content === undefined || this.content === "") {
        return false;
      }

      return true;
    },

    getUuid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    dataURLtoFile(dataurl, fileName) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName + "." + mime.split("/")[1], {
        type: mime,
      });
    },
    getBase64(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function() {
        return reader.result;
      };
      reader.onerror = function(error) {
        console.log("Error: ", error);
      };
    },
    imgAddHandler(file, Editor, cursorLocation, resetUploader) {
      var reader = new FileReader();
      let aa;
      reader.readAsDataURL(file);
      reader.onload = function() {
        aa = reader.result;

        Editor.insertEmbed(cursorLocation, "image", aa);
        resetUploader();
      };
    },
    uploadNews() {
      let uuid = this.getUuid();
      let imageCount = 0;

      if (this.inputCategory === "notice") {
        let quill = this.$refs.editor.quill;
        let contentList = quill.editor.delta.ops;
        let newContentList = [];
        contentList.forEach((element) => {
          if (element.insert.image !== undefined) {
            let imgFile = this.dataURLtoFile(
              element.insert.image,
              uuid + "_" + imageCount
            );

            this.addFormData("IMAGE_" + imageCount, imgFile);

            element.insert.image =
              "https://ddley2bvkb71v.cloudfront.net/news/" + imgFile.name;
            imageCount++;
          }
          newContentList.push(element);
        });
        quill.setContents(newContentList);
      }

      if (this.checkValidation()) {
        this.setNoticeData(uuid);
        this.isReady = false;
        fileUpload(this.formData).then((result) => {
          if (result.status === 200) {
            this.formData = new FormData();
            this.$router.push("/news");
          } else {
            alert("등록에 실패했습니다.");
          }
        });
      } else {
        alert("빈칸을 채워주세요.");
      }
    },
    setNoticeData(uuid) {
      this.addFormData("KEY", uuid);
      this.addFormData("TITLE", this.inputTitle);
      this.addFormData("DATE", this.inputDate);
      this.addFormData("CATEGORY", this.inputCategory);
      this.addFormData("CONTENT", this.content);
    },
    addFormData(key, value) {
      this.formData.append(key, value);
    },
  },
};
</script>

<style scoped>
.article-wrapper {
  text-align: left;
}
.article-info {
  padding-bottom: 40px;
  /* border-bottom: 1px solid #d5d5d5; */
}
.editor {
  margin-top: 40px;
  border-top: 1px solid #d5d5d5;
  /* padding: 0px 0; */
  padding-top: 40px;
  /* padding: 40px 0;
  border-top: 1px solid #d5d5d5; */
}
.btn-complete {
  width: 120px;
  height: 48px;
  margin: 0 auto;
  margin-bottom: calc(100px - 2rem);
  background-color: #e94424;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
}
.title {
  font-size: 16px;
  color: #5a5a5a;
  padding: 10px 0;
}
input {
  padding: 18px 20px;
  width: calc(100% - 42px);
  color: #b9b9b9;
  border: 1px solid #b9b9b9;
}
.category div:nth-child(1) {
  width: 20%;
}
.category div:nth-child(2) {
  width: 100%;
}
select {
  width: 90%; /* 원하는 너비설정 */
  color: #b9b9b9;
  padding: 18px 20px; /* 여백으로 높이 설정 */
  font-family: inherit; /* 폰트 상속 */
  border: 1px solid #b9b9b9;
  border-radius: 0px; /* iOS 둥근모서리 제거 */
}

.article-wrapper >>> .typing_loader {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  z-index: 999;
}
.opacity0-3 {
  opacity: 0.3;
}
</style>
